import { ClearAssetsCacheBtn } from "../../components/utils/clearAssetsCacheBtn/clearAssetsCacheBtn";
import { ClearCacheBtn } from "../../components/utils/clearCacheBtn/clearCacheBtn";

export const utilsComponents = {
    clear_cf_cache_id: ClearCacheBtn,
    clear_assets_cache_id: ClearAssetsCacheBtn
}